/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberEight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M178.76923,71.66667a46.108,46.108,0,0,1-14.87,33.70542,53.13546,53.13546,0,0,1-71.79854,0,45.63467,45.63467,0,0,1,0-67.41085,53.13546,53.13546,0,0,1,71.79854,0A46.108,46.108,0,0,1,178.76923,71.66667Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M188,175.66667a54.49122,54.49122,0,0,1-17.57359,39.83368,62.79644,62.79644,0,0,1-84.85282,0,53.93188,53.93188,0,0,1,0-79.66737,62.79644,62.79644,0,0,1,84.85282,0A54.49124,54.49124,0,0,1,188,175.66667Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default NumberEight;
